import { Box, styled } from '@mui/material'

import { TabPanelLocation } from '@tabeeb/enums'
import { ToggleButtonGroup } from '@collaborate-health/uikit'

export const PanelButtonGroup = styled(ToggleButtonGroup)(() => ({
  [`&[data-location="${TabPanelLocation.Left}"]`]: {
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
  },

  [`&[data-location="${TabPanelLocation.Right}"]`]: {
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
  },

  [`&[data-location="${TabPanelLocation.Bottom}"]`]: {
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
  },
}))

export const ExpandButtonContainer = styled(Box)<{ orientation: 'left' | 'right' }>(({ theme, orientation }) => ({
  position: 'absolute',
  top: '50%',
  zIndex: 1,
  backgroundColor: theme.palette.background.paper,
  ...(orientation === 'left' && { left: '16px' }),
}))

